import React from "react";
import AdminNavbar from "./AdminNavbar";
import useNoIndex from "./useNoIndex";

export default function AdminLayout({
    title,
    eyebrow,
    intro,
    showNavLinks = true,
    showLogout = false,
    centered = false,
    pageClassName = "",
    children,
}) {
    useNoIndex(title);

    return (
        <div className={`fisp-tv tv-admin-page ${pageClassName}`.trim()}>
            <AdminNavbar showLinks={showNavLinks} showLogout={showLogout} />

            <main className={`tv-admin-main ${centered ? "is-centered" : ""}`}>
                <div className="tv-admin-shell">
                    {(title || intro || eyebrow) ? (
                        <section className="tv-admin-hero">
                            {eyebrow ? <span>{eyebrow}</span> : null}
                            {title ? <h1>{title}</h1> : null}
                            {intro ? <p>{intro}</p> : null}
                        </section>
                    ) : null}

                    {children}
                </div>
            </main>
        </div>
    );
}
